import { ApplicationSettings } from "@app/shared/system/application-settings";

export class LiveTrackerSettings {
    
    version: string;
    address:string;

}
